
import { MatSnackBar } from '@angular/material/snack-bar';
import { Message } from '../http/message';
import { MessageSeverity } from '../http/message-severity';
import { CustomSnackBarComponent } from './custom-snackbar/custom-snackbar.component';

export class NotificationManager {

    constructor() {
    }

    static handleSuccess(success: string, snackBar: MatSnackBar) {
        const msg = new Message(success, MessageSeverity.Success);
        snackBar.openFromComponent(CustomSnackBarComponent, { data: msg, horizontalPosition: 'center' });
    }

    static handleWarning(warning: string, snackBar: MatSnackBar) {
        const msg = new Message(warning, MessageSeverity.Warning);
        snackBar.openFromComponent(CustomSnackBarComponent, { data: msg, horizontalPosition: 'center' });
    }

    static handleError(error: string, snackBar: MatSnackBar) {
        const msg = new Message(error, MessageSeverity.Error);
        snackBar.openFromComponent(CustomSnackBarComponent, { data: msg, horizontalPosition: 'center' });
    }
}
